import { render, staticRenderFns } from "./BaseHeaderAddUser.vue?vue&type=template&id=03196779&scoped=true&"
import script from "./BaseHeaderAddUser.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderAddUser.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderAddUser.vue?vue&type=style&index=0&id=03196779&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03196779",
  null
  
)

export default component.exports